<template>
  <div class="mapping">
    <div class="content">

      <div class="newtable-title">
        <div class="left-t">
          <span>产能稼动率</span>
        </div>
        <!-- <div class="btns">
          <el-button type="primary" @click="add_ed(0)">手工填报</el-button>
          <el-button type="primary" @click="exportList" class="last-el-button">导出</el-button>
        </div> -->

      </div>
      <div class="unify-search-input-btn">
        <div class="input-small">
          <span class="search-name">模型：</span>
          <el-cascader ref="cascader" v-model="workshop" :options="options" @change='changeSelect'
            :props="{ checkStrictly: true,label:'modelName',value:'id' }" :show-all-levels="false"></el-cascader>
          <span class="search-name ml-2">时间：</span>
          <el-date-picker v-model="startDate" type="month" placeholder="选择时间" :picker-options="pickerOptions">
          </el-date-picker>
          <el-button type="primary" @click="getList" plain class="search-btn">查询</el-button>
        </div>

      </div>
      <div id="echart"></div>
      <!-- <div class="mapping-table">
        <el-table :data="tableData" v-loading="loading" stripe style="width: 100%" :height="heights">
             <template slot="empty">
          <span class="noData">
            <img src="../../assets/noData.png" alt="暂无数据">
            <span class="text">暂无数据</span>
          </span>
        </template>
          <el-table-column label="序号" width="90" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="稼动率占比" width="204">
            <template slot-scope="scope"><span>{{ scope.row.kadouritsuProportion[labeled] }}</span></template>
          </el-table-column>
          <el-table-column prop="kadouritsuTime" label="稼动率时间" width="204" />
        </el-table>
      </div>
      <downloadTable ref="downloadTable"></downloadTable> -->
    </div>

    <!-- 新增修改 -->
    <el-dialog width="30%" v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false'
      :visible.sync="dialogVisible">
      <div class="dialogs">

        <el-form :model="temp" ref="temp" :rules="rules" style="width: 80%;height: 180px;padding-top: 10px;">
          <el-form-item label="映射名称:" prop="capacityName">
            <el-input v-model="temp.capacityName" disabled></el-input>
          </el-form-item>

          <el-form-item label="产量:" prop="capacityValue">
            <el-input v-model="temp.capacityValue"></el-input>
          </el-form-item>
          <el-form-item label="日期:" prop="recordDay">
            <el-date-picker v-model="temp.recordDay" type="date" size="mini" placeholder="选择日期"
              :disabled='editType == 0' :picker-options="pickerOptions"> </el-date-picker>
            <!-- <p style="color:#5e6d82;font-size:12px">Tip：多个设备请用英文逗号隔开</p> -->
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {getMappingList,recordFindList,recordUpdateValue,recordSave,recordUpdateInfo} from "../../api/capacity";
  import elRadioTree from '@/components/module/tree/elRadioTree.vue'
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  import request from "@/api/http.js";
  import * as echarts from "echarts";
  import $ from 'jquery';
  var echart;
  export default {
    components: {
      elRadioTree,
      downloadTable
    },
    data () {
      return {
        middleData: {
          legend: {
            // data: ["1号建筑", "2号建筑", "3号建筑", "4号建筑",],
            data: [],
            top: 220,
            icon: "rect", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 12, // 设置宽度
            itemHeight: 12, // 设置高度
            textStyle: {
              lineHeight: 56,
              fontSize: 14
            },
            itemGap: 50 // 设置间距
          },
          grid: {
            top: "8% ",
            left: 52,
            right: 25,
            bottom: 60
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow" // 'shadow' as default; can also be 'line' or 'shadow'
            }
          },
          toolbox: {
            show: true,
            showTitle: true, // 隐藏默认文字，否则两者位置会重叠
            right: '2%',
            top: '1%',
            feature: {
              magicType: {
                type: ['bar','stack','tiled'],title: {
                  bar: '切换为柱状图',
                  stack: '切换为堆叠',
                  tiled: '切换为平铺',
                }
              },
              saveAsImage: {
                show: true,
                title: '下载图片'
              },
              // dataView: { show: true, readOnly: true, lang: ['', '关闭'] },
            },
            tooltip: { // 和 option.tooltip 的配置项相同
              show: false,
              formatter: function(param) {
                return '<div>'+param.title+'</div>'; // 自定义的 DOM 结构
              },
              backgroundColor: '#fff',
              textStyle: {
                fontSize: 12,
              },
              extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);' // 自定义的 CSS 样式
            }
          },
          color: ["#60ACF2",'#6071F2','#FBD437','#36CBCB','#F56C6C','#67C23A','#409EFF','#E6A23C','#909399'],

          xAxis: {
            splitLine: {
              //网格线
              show: true
            },
            splitArea: {
              //坐标轴在 grid 区域中的分隔区域，默认不显示。
              interval: "auto",
              show: false, //是否显示分隔区域
              areaStyle: {
                color: ["rgba(250,250,250,0.3)","rgba(200,200,200,0.3)"], //分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
                shadowColor: "red", //阴影颜色
                shadowOffsetX: 0, //阴影水平方向上的偏移距离。
                shadowOffsetY: 0, //阴影垂直方向上的偏移距离
                shadowBlur: 10, //图形阴影的模糊大小。
                opacity: 1 //图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形
              }
            },
            type: "category",
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false
            },
            axisLine: {
              show: false
            },
            z: 99,
            data: [
              "00：00",
              "00：15",
              "00：30",
              "00：45",
              "01：00",
              "01：15",
              "01：30",
              "01：45",
              "02：00",
              "02：15",
              "02：30",
              "03：00",
            ]
          },
          yAxis: {
            type: "value"
          },
          series: [{

            data: [1,2,4,5,6],
            type: "bar",
            stack: 'total',
            emphasis: {
              focus: 'series'
            },
            barWidth: 25 //柱图宽度
          }]
        },

        heights: document.getElementById('app').clientHeight-250,//屏幕高度 - 导航栏高度
        loading: false,
        dialogVisible: false,
        dialogStatus: '',
        labeled: '',//选中工序名称
        textMap: {
          add: "新增填报",
          edit: "编辑填报"
        },
        temp: {
          'capacityName': "",
          'localDevice': "",
          'localDeviceNo': ""
        },
        rules: {
          capacityName: [
            {required: true,message: '请输入映射名称',trigger: 'blur'}
          ],
          recordDay: [
            {required: true,message: '请选择日期',trigger: 'blur'}
          ],
          capacityValue: [
            {required: true,message: '请输入产量',trigger: 'blur'}
          ]
        },
        tableData: [],
        startDate: "",
        endDate: new Date(),
        options: [],
        nowWorkshop: {},
        workshop: '',
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },

        },
        editType: 0
      };
    },

    mounted () {
      // 建筑-综合用能-日统计
      echart=echarts.init(document.getElementById("echart"));
      echart.setOption(this.middleData);
      echart.resize({height: 560});
      //    this.getList()
      this.getSelectList()
      var date=new Date();
      date.setDate(1);
      var cTime=new Date(new Date(date).toLocaleDateString()).getTime();
      this.startDate=cTime

    },
    computed: {
      unitId () {
        return this.$store.unitStore.state.nowUnit
      },
    },
    watch: {
      unitId () {
        this.getSelectList()
      },
    },

    methods: {
      echartFn (val) {

        this.middleData.xAxis.data=[];
        this.middleData.series=[]
        var name=[] //

        val.map((v,i) => {
          this.middleData.xAxis.data.push(v.kadouritsuTime.slice(-2)+'号');
          for(const key in v.kadouritsuProportion) {
            name.push(key)
          }
          // this.middleData.series[0].data.push(v.kadouritsuProportion[this.labeled]||'-')
        })
        console.log(name,'name');
        // 1.利用set去重  
        let newList=Array.from(new Set(name));

        newList.map(a => {
          var d=[]
          val.map((b) => {
            d.push(b.kadouritsuProportion[a]||'-')
          })
          this.middleData.series.push({
            name: a,
            data: d,
            tooltip: {
              valueFormatter: function(value) {
                if(value=='-') {
                  return value
                } else {
                  return value+'%';
                }
              }
            },
            type: "bar",
            // stack: 'total',
            // emphasis: {
            //   focus: 'series'
            // },
            // barWidth: 25 //柱图宽度
          })

        })
        console.log(this.middleData,'this.middleData');
        echart.setOption(this.middleData,true);
      },
      //获取下拉框列表
      getSelectList () {
        var params={'unitId': this.unitId.id}
        this.tableData=[];
        request({url: "/dissipation/model/findModelTree",method: "get",params}).then(res => {
          console.log(res,'111');
          if(res.code==200) {
            this.options=res.data.children
            this.workshop=[this.options[0].id];
            this.getList()
          } else {
            res.message? this.$message.error(res.message):this.$message.error('添加失败')
          }
        })
      },
      //获取数据
      getList () {
        this.loading=true;
        console.log(this.workshop);
        var params={
          capacityId: this.workshop[this.workshop.length-1],
          selectDate: typeof this.startDate=='number'? this.startDate:this.startDate.getTime(),
        }

        request({url: "/dissipation/record/kadouritsu",method: "get",params}).then(res => {
          console.log(res,'res');
          if(res.code==200) {
            var d=this.$refs.cascader.getCheckedNodes();
            this.labeled=d[0].label;
            this.tableData=res.data;
            this.echartFn(this.tableData)
          } else {
            res.message? this.$message.error(res.message):this.$message.error('查询失败，请检查配置！！')
          }
          this.loading=false
        })

      },
      //下拉框
      changeSelect (val) {
        console.log(val,'val');
        this.getList()
      },

      // 添加弹窗
      add_ed (v,l) {
        this.editType=1
        this.temp={}
        this.temp.capacityName=this.nowWorkshop.capacityName
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.topLevel=v
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        // this.temp = { EnergyTypeParentId: v || null};
      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate(valid => {
          if(valid) {
            var d={
              sourcesType: "MANUAL",
              capacityValue: this.temp.capacityValue,
              recordDay: this.temp.recordDay.getTime(),
              sourcesId: this.nowWorkshop.id,
            }
            recordSave(d).then(res => {
              if(res.code==200) {
                //  var data = res.data
                //  data.capacityName = this.nowWorkshop.capacityName
                this.getList();
                // this.tableData.push(data)
                this.dialogVisible=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error('添加失败');
                }
              }
            })


          } else {
            return false;
          }
        });
      },

      // 确认编辑
      edit_fn () {
        this.$refs['temp'].validate(valid => {
          if(valid) {
            var data=this.temp
            var d={
              "capacityValue": data.capacityValue,
              "id": data.id,
            }
            console.log(d);
            var index=this.tableData.findIndex(item => item.id==data.id)
            if(this.editType==0) { //修正
              recordUpdateValue(d).then(res => {
                if(res.code==200) {
                  //  this.getList();
                  this.tableData[index].capacityValue=res.data.capacityValue
                  this.dialogVisible=false;
                  this.$message({showClose: true,message: '修正成功',type: 'success'});
                } else {
                  res.message? this.$message.error(res.message):this.$message.error('修正失败')

                }
              })
            } else { //编辑
              d.recordDay=typeof data.recordDay=='number'? data.recordDay:data.recordDay.getTime()
              recordUpdateInfo(d).then(res => {
                if(res.code==200) {
                  //  this.tableData[index].capacityValue = res.data.capacityValue
                  this.getList();
                  this.dialogVisible=false;
                  this.$message({showClose: true,message: '编辑成功',type: 'success'});
                } else {
                  res.message? this.$message.error(res.message):this.$message.error('编辑失败')
                }
              })
            }

          } else {
            return false;
          }
        });
      },
      //编辑弹窗 0 为自动填报，1为手工填报
      edit_ed (v,type) {
        if(type==0) {
          this.textMap.edit='修正自动填报'
        } else {
          this.textMap.edit='编辑手工填报'
        }
        this.editType=type

        this.dialogStatus='edit';
        this.temp=Object.assign({},v);
        this.temp.capacityName=this.nowWorkshop.capacityName
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });




      },
      //下载表格excel
      exportList () {
        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();

        const tHeader=[];
        this.$refs.downloadTable.export2Excel(tHeader,this.tableData,year+"-"+month+"-"+day+'-产量管理','.mapping-table')
      },



    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';
        let strDate=Y+M+D;
        return strDate
      },
    }
  };
</script>

<style lang="scss" scoped>
  .mapping {
    width: 100%;
    height: 100%;
    background-color: #ebf4ff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;

    .content {
      width: 100%;
      height: 100%;
      padding: 20px;
      box-sizing: border-box;
      background-color: #fff;

      .mapping-table {
        margin-top: 20px;

        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .buttoned_box {
          display: flex;
          justify-content: center;
          align-items: center;

          .line {
            display: inline-block;
            width: 1px;
            height: 20px;
            background-color: #E6E6E6;
            margin: 0px 20px;
          }

          .buttoned {
            cursor: pointer;
          }

          /deep/.el-button span {
            font-size: 15px;
            font-weight: 400;
          }
        }
      }

    }

    .dialogs {
      /deep/.el-input__inner {
        width: 250px;
      }
    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #f5f5f5;

      span {
        color: #67A3ED;
        font-size: 16px;
      }

      .el-icon-close {
        font-size: 22px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #f5f5f5;

      button {
        padding: 8px 17px;
      }
    }

    /deep/.el_Tree_Body {
      height: 99.5%;
    }

    .demo-temp {
      display: flex;
      flex-wrap: wrap;
    }

    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 85px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }


  }
</style>